import {Directive, Input, TemplateRef} from '@angular/core';
import {CustomFieldMode} from '../define';

@Directive({
  selector: '[gcUserField]'
})
export class UserFieldDirective {

  @Input() name = null;
  @Input() mode: CustomFieldMode  = 'both';

  constructor(public template: TemplateRef<any>) { }

}
